module.exports = __webpack_public_path__ + "img/symphony_724_spring.e8478ec0.jpg";